import { useTranslation } from "react-i18next";
import { Link } from "react-router";
import PageWrapper from "components/page/PageWrapper";
import bg from 'assets/images/banner/banner01.jpg';
import imgPartner from 'assets/images/partners/img_partner.jpg';

export default function Partners(){
  const {t} = useTranslation();
  const menuName= t('menu.main-partners');
  const path=[{url:'/partners', name:t('menu.main-partners')}];
  const title = t('partners.banner.title')
  const comment = t('partners.banner.comment');

  const images = [];
  for(let i=1; i < 9; i++)
    images.push( require(`assets/images/partners/${i}.png`));
  const addrs = [
    'https://www.trinasolar.com/en-apac',
    'https://www.jinkosolar.com/kr',
    'https://www.tigoenergy.com/',
    'https://kor.sungrowpower.com',
    'https://www.hyundai-es.co.kr/index.do',
    '#',
    'https://qcells.com/kr/',
    'https://www.longi.com/kr/',
  ];

  const links = images.map((img, index)=>{
    return(
      <div className="h-[93px] m-2 border border-gray-200 border-solid hover:border-hover flex flex-col justify-center">
        <Link to={addrs[index]}>
          <img src={img} className="w-[261px]" alt={addrs[index]}/>
        </Link>
      </div>
    );
  });

  return (
    <PageWrapper 
      bg={bg} 
      menuName={menuName}
      title={title}
      comment={comment}
      path={path}>
      <div className="flex justify-center">
      <div className={`flex flex-col items-center mx-mobile lg:mx-pc mb-20 lg:w-[1200px]`}>
        <div className={`flex flex-col-reverse lg:flex-row lg:items-center`}>
          <img src={imgPartner} alt='partners menu banner'/>
          <div className="lg:ml-20">
            <p className="mb-6 text-xl font-bold">{t('partners.body.title')}</p>
            <p className="mb-6 text-3xl font-thin text-gray-600 lg:text-5xl">{t('partners.body.sub-title')}</p>
            <p className="mb-6 text-xs text-gray-500 lg:text-lg" 
              dangerouslySetInnerHTML={{__html:t('partners.body.comment')}}></p>
          </div>
        </div>
        {/* partners */}
        <div className={`flex flex-col mt-20`}>
          <div className={`flex flex-col lg:flex-row`}>
            <div className="flex flex-row items-center">{links[0]}{links[1]}</div>
            <div className="flex flex-row items-center">{links[2]}{links[3]}</div>
          </div>
          <div className={`flex flex-col lg:flex-row`}>
           <div className="flex flex-row items-center">{links[4]}{links[5]}</div>
           <div className="flex flex-row items-center">{links[6]}{links[7]}</div>
          </div>
        </div>
      </div>
      </div>
    </PageWrapper>
  );
}
